import React, { forwardRef, useImperativeHandle } from 'react'
import Api from '../../../../_helpers/Api'
import { useHistory, useLocation, Link } from 'react-router-dom'
import { useEffect, useRef, useState } from 'react'
import Filter from './Filter'
import Skeleton from 'react-loading-skeleton'
import SendMessage from './SendMessage'
import Question from '../../../modals/messages/Question'
import Pagination from '../../../Pagination'
import AddOrEdit from './AddOrEdit'
import NoDataFound from '../../../partials/NoDataFound'
import Options from './ListOptions'
import { trans } from '../../../../_providers/Translation'
import closeIcon from '../../../../assets/img/icons/close.png'
import checkIcon from '../../../../assets/img/icons/check.png'
import { createPortal } from 'react-dom'
import ServicingOptions from './ServicingOptions'
import moment from 'moment'
import ReactTooltip from 'react-tooltip'

let timeout

function Index(props, ref) {
    const location = useLocation()
    const history = useHistory()

    const searchParams = new URLSearchParams(location.search)

    const modalAddOrEditRef = useRef(null)
    const modalQuestionRef = useRef(null)
    //  const modalSendMessageRef = useRef(null)

    const page = searchParams.get('page') || 1
    const name = searchParams.get('name') || ''
    const typeId = searchParams.get('type_value') || ''

    const [data, setData] = useState({
        loading: true,
        data: [],
        types: [],
        total: 0,
        pages: 0,
        page: page,
        filter: {},
        setFilter: false,
        update: false,
    })

    useImperativeHandle(ref, () => ({
        add: () => {
            handleAdd()
        }
    }))

    useEffect(() => {
        setData(prev => ({
            ...prev,
            page: page,
            filter: {
                ...prev.filter,
                name: name,
                type_value: typeId
            },
            update: new Date().getTime()
        }))
    }, [page, name, typeId])

    useEffect(() => {
        if (data.setFilter) {
            searchParams.set('page', data.page)

            Object.entries(data.filter).map(filter => {
                // if (filter[1]) {
                searchParams.set(filter[0], filter[1])
                // }
            })

            let url = '?' + searchParams.toString()

            history.push(url)
        }

    }, [data.setFilter])

    useEffect(() => {
        if (data.update) {
            loadContractors()
        }
    }, [data.update])

    // read
    const loadContractors = () => {

        setData(prev => ({
            ...prev,
            loading: true
        }))

        let url = 'contractors/appliances/serviced?page=' + data.page

        Object.entries(data.filter).map(filter => {
            url += '&' + filter[0] + '=' + filter[1]
        })

        Api.get(url)
            .then(res => {
                setData(prev => ({
                    ...prev,
                    loading: false,
                    data: res.data.items,
                    pages: res.data.pages,
                    total: res.data.total,
                    types: res.data.types
                }))
            }).catch(err => {
                setData(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }

    //Search
    const handleSearch = (key, val) => {
        clearTimeout(timeout)

        setData(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                [key]: val,
            },
        }))

        timeout = setTimeout(() => {
            setData(prev => ({
                ...prev,
                page: 1,
                setFilter: new Date().getTime()
            }))
        }, 300)
    }

    // create
    const handleAdd = () => {
        modalAddOrEditRef.current.add()
    }

    const handleCreate = () => {
        setData(prev => ({
            ...prev,
            update: Math.random().toString()
        }))
    }

    // update
    const handleEdit = id => {
        modalAddOrEditRef.current.edit(id)
    }

    // const handleEditType = id => {
    //     modalAddOrEditTypeRef.current.edit(id)
    // }

    const handleUpdate = row => {

        let updated = data.data.map(i => {
            if (i.id == row.id) {
                i = row
            }
            return i
        })

        setData(prev => ({
            ...prev,
            data: updated,
        }))
    }

    // delete
    const handleDestroy = id => {

        let url = 'contractors/delete'

        Api.post(url, {
            id: id
        }).then(res => {
            if (res.data.success) {
                let filtered = data.data.filter(i => {
                    return i.id !== id
                })

                setData(prev => ({
                    ...prev,
                    data: filtered
                }))

                modalQuestionRef.current.close()
            }
        })
    }

    // Question modal
    const handleDelete = id => {
        modalQuestionRef.current.open(id)

        modalQuestionRef.current.onSuccess(() => {
            handleDestroy(id)
        })
    }

    const handlePage = page => {
        setData(prev => ({ ...prev, page: page.selected + 1, setFilter: new Date().getTime() }))
    }

    return (
        <>
            <AddOrEdit
                ref={modalAddOrEditRef}
                handleCreate={handleCreate}
                handleUpdate={handleUpdate}
            />

            <Question
                ref={modalQuestionRef}
                mainMessage={trans('headings.confirmDelete')}
                secondaryMessage={trans('subheadings.confirmDelete')}
            />
            <div className='pannel'>
                <h3>{trans('subheadings.servicingMain')}</h3>
                <Filter
                    filter={data.filter}
                    types={data.types}
                    handleSearch={handleSearch}
                />
                <hr />
                {console.log(data.data)}
                {data.loading
                    ?
                    <Skeleton height={45} count={10} />
                    :
                    data.data.length === 0
                        ?
                        <NoDataFound />
                        :
                        <>
                            <div className="table-scroller">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>
                                                {trans('tables.company')}
                                            </th>
                                            <th>
                                                {trans('tables.reservation')}
                                            </th>
                                            <th style={{ width: '5%' }}>
                                                {trans('tables.type')}
                                            </th>
                                            <th style={{ width: '10%' }}>
                                                {trans('tables.devicesCount')}
                                            </th>
                                            <th style={{ width: '10%' }}>
                                                {trans('tables.servicingDate')}
                                            </th>
                                            <th className="options">
                                                {trans('tables.options')}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.data.map(c =>
                                            <tr key={c.id}>
                                                <td>
                                                    <Link to={'contractors/preview/' + c.contractor?.id}>
                                                        {c.contractor?.name || "-"}
                                                    </Link>
                                                </td>
                                                <td>
                                                    {c?.reservation ?
                                                        <Link
                                                            to={`/schedule/reservations/edit/${c?.reservation?.id}`}
                                                            className="btn"
                                                            style={{ background: c?.reservation?.color, color: c?.reservation?.text_color }}
                                                            data-tip
                                                            data-for={'tooltip-r-' + c?.reservation?.id}
                                                        >
                                                            {c?.reservation?.reference_code}
                                                        </Link>
                                                        :
                                                        "-"
                                                    }
                                                </td>
                                                <td style={{ width: '5%' }}>
                                                    {c.type === "subscription" ? trans('labels.subscription') : c.type === "warranty" ? trans('labels.warranty') : "-"}
                                                </td>
                                                <td style={{ width: '10%' }}>
                                                    {c.appliances.length}
                                                </td>
                                                <td style={{ width: '10%' }}>
                                                    {moment(c.date_of_first_servicing, 'YYYY-MM-DD').format('DD.MM.YYYY')}
                                                </td>

                                                <td className="options">
                                                    <ServicingOptions
                                                        id={c.id}
                                                        handleDelete={handleDelete}
                                                    />
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <Pagination
                                pages={data.pages}
                                page={data.page}
                                handlePage={handlePage}
                            />
                        </>
                }
            </div>
        </>


    )
}

export default forwardRef(Index)